import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	intuitConnection: null,
	loading: false,
	loadingSubmit: false
};

export default function intuitConnectionBasicPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_INTUIT_CONNECTION_BASIC_REQUEST:
		case ActionTypes.GET_INTUIT_CONNECTION_BASIC_ERROR:
		case ActionTypes.GET_INTUIT_CONNECTION_BASIC_SUCCESS:
		case ActionTypes.SUBMIT_INTUIT_CONNECTION_REQUEST:
		case ActionTypes.SUBMIT_INTUIT_CONNECTION_ERROR:
		case ActionTypes.SUBMIT_INTUIT_CONNECTION_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_INTUIT_CONNECTION_BASIC_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_INTUIT_CONNECTION_BASIC_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
